/**
 * How monetization affects what users see in the product.
 * Behavioral rules only — no payment or ranking implementation.
 */
export interface MonetizationVisibilityRule {
  readonly id: string;
  readonly rule: string;
  readonly userFacingEffect: string;
}

export const MONETIZATION_VISIBILITY_RULES: readonly MonetizationVisibilityRule[] = [
  {
    id: 'products_in_creator_profile',
    rule: 'Published products always appear on the creator public profile.',
    userFacingEffect: 'Anyone viewing a creator can browse their digital products on the profile page.',
  },
  {
    id: 'products_in_feed_when_monetizing',
    rule: 'Products may appear in the feed once a creator reaches monetizing lifecycle state.',
    userFacingEffect:
      'Monetizing creators can have product cards mixed into discovery surfaces, not only posts.',
  },
  {
    id: 'purchase_boosts_visibility',
    rule: 'Completed purchases influence creator visibility positively.',
    userFacingEffect:
      'Creators who generate sales are rewarded with greater distribution because buyers validate their value.',
  },
  {
    id: 'storefront_prominence_threshold',
    rule: 'The creator storefront becomes prominent after sustained product activity.',
    userFacingEffect:
      'Once a creator regularly sells products, their profile and feed presence emphasize commerce (products, pricing, purchase actions).',
  },
  {
    id: 'free_tier_limited_studio',
    rule: 'Free-tier creators have limited studio and visibility compared to pro creators.',
    userFacingEffect:
      'Pro creators receive stronger studio access and implicitly higher platform visibility weight.',
  },
  {
    id: 'no_unpublished_products_in_feed',
    rule: 'Draft or unpublished products never appear in public surfaces.',
    userFacingEffect: 'Users only see products creators have explicitly published.',
  },
];

export type MonetizationVisibilityRules = typeof MONETIZATION_VISIBILITY_RULES;
